/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var IOS7 = mp.marketing.trends.widgets.OSAdoption.extend({
    get_previous_version() {
      return mp.marketing.trends.utils.IOS_6;
    },
    get_new_version() {
      return mp.marketing.trends.utils.IOS_7;
    },

    getDownloadName() {
      return ns.IOS7.nice_name;
    },
  });

  Object.assign(IOS7, {
    slug: `ios_7`,
    nice_name: `iOS 7 adoption`,
    description: `How quickly are consumers upgrading to iOS 7?`,
  });
  ns.IOS7 = IOS7;
});

}.call(window));